'use strict';

const $ = window.jQuery;

export default class Nav {
    constructor() {
        $('.nav-main-l1__link').on('click', function (e) {
            // Reset all deployed components
            $('.header-account-deployer, .header-account-menu, .header-search-input, .lang-selector-deployer, .lang-selector-list, .nav-main-l1__link, .mega-menu').removeClass('is-active');

            setTimeout(() => {
                $('.mega-menu__list__link, .mega-menu__right__container').removeClass('is-active');
                $(`.is-parent`).addClass('is-active');
            }, 200);

            if ($(this).hasClass('is-active')) {
                e.stopPropagation();
                e.preventDefault();
            } else if ($(this).hasClass('has-children')) {
                e.stopPropagation();
                e.preventDefault();

                // Deploy megamenu
                $(this).addClass('is-active');
                $(this).next().toggleClass('is-active');
            }
        });

        $('.mega-menu__list__link').on('mouseenter', function () {
            const that = $(this);
            $('.mega-menu__list__link').removeClass('is-active');
            $(`.mega-menu__right__container`).stop();

            if (that.hasClass('has-informations')) {
                that.addClass('is-active').parents('.mega-menu').find(`.mega-menu__right__container`).removeClass('is-active');
                $(`.${$(this).data('informations')}`).addClass('is-active');
            } else {
                $(`[class*="informations-"]`).removeClass('is-active');
                $(this).parents('.mega-menu').find('.is-parent').addClass('is-active');
            }
        });

        $('.mega-menu').on('click', function (e) {
            e.stopPropagation();
        });

        $(window).on('scroll', function () {
            if ($(window).width() > 1023) {
                $('.nav-main-l1__link, .mega-menu').removeClass('is-active');

                setTimeout(() => {
                    $('.mega-menu__list__link, .mega-menu__right__container').removeClass('is-active');
                    $(`.is-parent`).addClass('is-active');
                }, 200);
            }
        });

        // Close items
        $('body').on('click', function () {
            $('.nav-main-l1__link, .mega-menu').removeClass('is-active');

            setTimeout(() => {
                $('.mega-menu__list__link, .mega-menu__right__container').removeClass('is-active');
                $(`.is-parent`).addClass('is-active');
            }, 200);
        });
    }
}
